import { API_ADMIN_GET_CACHE, API_ADMIN_FLUSH_CACHE } from "actions/cache";
export function adminGetCache() {
	return {
		type: API_ADMIN_GET_CACHE,
		payload: {
			request: {
				url: `/c`,
			},
		},
	};
}

export function adminFlushCache() {
	return {
		type: API_ADMIN_FLUSH_CACHE,
		payload: {
			request: {
				url: `/c`,
				method: "DELETE",
			},
		},
	};
}
